// The side space of a page — the one place it is set. Kept the same as the funnel's `app/components/layout/pageWidth.ts` so the two
// sites leave the same gap on the left and right of a screen: from `lg` (1024px) up the column is 86% of the screen, never more than
// 85rem; below that it is the whole screen with a small padding each side.
//
// To change the gap on every screen that uses this, change the two numbers in `DESKTOP`: `lg:w-[86%]` (how much of the screen the
// column takes — smaller means more gap) and `lg:max-w-[85rem]` (how wide it may get). They are written out in full, not built from
// variables, because Tailwind only creates the classes it can read in the source.
//
// A screen takes `PAGE_CONTAINER` for its column and puts its own classes after it:
//   <section className={`${PAGE_CONTAINER} pt-6 pb-10`}>

/** The part that sets the gap from `lg` up. */
const DESKTOP = "lg:w-[86%] lg:max-w-[85rem] lg:px-0";

export const PAGE_CONTAINER = `mx-auto max-w-[96rem] px-4 sm:px-6 ${DESKTOP}`;
export const PAGE_CONTAINER_TIGHT = `mx-auto max-w-[96rem] px-3 sm:px-6 ${DESKTOP}`;

// ── Banner height ──────────────────────────────────────────────────────────────────────────────────────────────────────────────
// How tall the banner at the top of the Community and Blogs screens is, from `lg` up — one value so the two are always the same. (Below
// `lg` the Blogs screen has no banner, and the Community banner is as tall as its words need, but never shorter than `min-h-[360px]`.)
export const BANNER_HEIGHT = "lg:h-[400px]";

// ── Colours ────────────────────────────────────────────────────────────────────────────────────────────────────────────────────
// The brand palette as hex codes, for the places that need the colour itself rather than a Tailwind class: an inline `style`, a chart,
// a canvas or a PDF. For anything in a `className`, use the utilities (`text-brand-blue`, `bg-brand-teal-strong`, …) — they come from the
// `--color-brand-*` tokens in `src/index.css`, which stay the source of truth, and the values here are kept the same as the funnel's
// (`app/components/layout/pageWidth.ts`). The numbered scales (`brand-50`…`brand-900`, `accent-50`…) are only in `index.css`.
export const BRAND_COLORS = {
  /** Primary dark blue — main text, icon base, logo "Roam" / "Way". */
  blue: "#1c4765",
  /** Accent teal — icon highlights, UI elements, primary CTAs. Fails AA contrast as text on white; use `tealStrong` for text and fills. */
  teal: "#459cae",
  /** Accent orange — logo "My", direction pointer, secondary CTAs. */
  orange: "#f7941d",
  white: "#ffffff",
  /** Light grey — secondary backgrounds, dividers. */
  grey: "#f5f5f5",
  /** Teal dark enough for text and button fills on white (4.7:1). */
  tealStrong: "#2e7e90",
  border: "#dde3e7",
  textSecondary: "#5f6b73",
  error: "#b3261e",
  success: "#1f7a55",
};
